<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="$parent.deleteMode"
            :width="width"
            center>
            <p style="text-align: center">{{ text }}</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmCallback()">Ja</el-button>
                <el-button @click="cancelClickCallback">Nein</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'DialogForm',
        data () {
            return {
                width: '30%',
            };
        },
        props: {
            title: {
                required: true,
                type: String,
            },
            text: {
                required: true,
                type: String,
            },
            deleteMode: {
                required: true,
            },
            confirmCallback: {
                required: true,
                type: Function,
            },
        },
        methods: {
            cancelClickCallback () {
                this.$parent.deleteMode = false;
            },
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/atoms/dialog/Delete.vue